/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type { ISTETHLike2, ISTETHLike2Interface } from "../ISTETHLike2";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_wstAmount",
        type: "uint256",
      },
    ],
    name: "getPooledEthByShares",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_ethAmount",
        type: "uint256",
      },
    ],
    name: "getSharesByPooledEth",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class ISTETHLike2__factory {
  static readonly abi = _abi;
  static createInterface(): ISTETHLike2Interface {
    return new utils.Interface(_abi) as ISTETHLike2Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ISTETHLike2 {
    return new Contract(address, _abi, signerOrProvider) as ISTETHLike2;
  }
}
